var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DomainToScope, LcBearerKey, LcRefreshBearerKey } from '../global';
import jwtDecode from 'jwt-decode';
import { HttpAuth } from './http.helper';
import { LocalStorageHelper } from './localstorage.helper';
import { IsNullOrEmpty } from './str.helper';
export class HttpAuthTokenHelper {
    static isExpiredFromLessThanOneHour(token = '') {
        return this.isExpired(token) && !this.isExpiredSinceOneHour(token);
    }
    static isExpired(token = '') {
        const decodedToken = this.decode(token);
        if (!decodedToken)
            return true;
        return decodedToken.exp < Math.floor(new Date().getTime() / 1000);
    }
    static isExpiredSinceOneHour(token = '') {
        const decodedToken = this.decode(token);
        if (!decodedToken)
            return false;
        const date = new Date();
        const dateToCompare = new Date(date.setHours(date.getHours() - 1));
        return decodedToken.exp < Math.floor(dateToCompare.getTime() / 1000);
    }
    static getExpirationTime(token = '') {
        const decodedToken = this.decode(token);
        if (!decodedToken)
            return (new Date().getTime() / 1000);
        return decodedToken.exp;
    }
    static isRealToken(token) {
        // An access token will have '.' in it (real defenition of an accessToken)
        return !IsNullOrEmpty(token) && token.indexOf('.') > 0;
    }
    static getRealToken(callAction, token = '') {
        return __awaiter(this, void 0, void 0, function* () {
            if (IsNullOrEmpty(token)) {
                token = this.getAccessTokenFromLocalStorage();
            }
            if (IsNullOrEmpty(token) || this.isRealToken(token)) {
                return { accessToken: token, refreshToken: null, numeroPersonnePhysique: null, idUtilisateur: null, email: null };
            }
            let realToken = null;
            try {
                const result = yield callAction(token);
                realToken = this.mapReceivedToken(result);
            }
            catch (error) {
                // TODO check error structure returned by the back
                // bad ref token or bad call (not handled by interceptor)
                return { accessToken: null, refreshToken: null, numeroPersonnePhysique: null, idUtilisateur: null, email: null };
            }
            return realToken;
        });
    }
    static mapReceivedToken(receivedToken) {
        const token = {
            accessToken: receivedToken === null || receivedToken === void 0 ? void 0 : receivedToken.accessToken,
            refreshToken: receivedToken === null || receivedToken === void 0 ? void 0 : receivedToken.refreshToken,
            numeroPersonnePhysique: receivedToken === null || receivedToken === void 0 ? void 0 : receivedToken.numeroPersonnePhysique,
            idUtilisateur: receivedToken === null || receivedToken === void 0 ? void 0 : receivedToken.idUtilisateur,
            email: receivedToken === null || receivedToken === void 0 ? void 0 : receivedToken.email
        };
        return token;
    }
    static decode(token = '') {
        if (IsNullOrEmpty(token)) {
            token = this.getToken(null);
        }
        let result = null;
        if (this.isRealToken(token)) {
            try {
                result = jwtDecode(token);
            }
            catch (error) {
                result = null;
                // failed to jwtdecode the token
            }
        }
        return result;
    }
    static setToken(token) {
        let workingToken = token;
        if (!token) {
            workingToken = { accessToken: null, refreshToken: null, numeroPersonnePhysique: null, idUtilisateur: null, email: null };
        }
        LocalStorageHelper.setItem(LcBearerKey, token.accessToken);
        LocalStorageHelper.setItem(LcRefreshBearerKey, token.refreshToken);
        HttpAuth.withBearer(token.accessToken);
    }
    static getAccessTokenFromLocalStorage() {
        return LocalStorageHelper.getItem(LcBearerKey);
    }
    static getRefreshTokenFromLocalStorage() {
        return LocalStorageHelper.getItem(LcRefreshBearerKey);
    }
    static getToken(to) {
        var _a;
        let token = ((_a = to === null || to === void 0 ? void 0 : to.query) === null || _a === void 0 ? void 0 : _a.token) ? to.query.token : null;
        if (!IsNullOrEmpty(token)) {
            const accessToken = { accessToken: token, refreshToken: null, numeroPersonnePhysique: null, idUtilisateur: null, email: null };
            this.setToken(accessToken);
        }
        else {
            token = this.getAccessTokenFromLocalStorage();
        }
        return token;
    }
    static isTokenValidForScope(encodedToken, currentDomain) {
        if (IsNullOrEmpty(encodedToken) || IsNullOrEmpty(currentDomain)) {
            return false;
        }
        const currentDomainPrefix = currentDomain.split('.')[0];
        const currentScope = DomainToScope[currentDomainPrefix];
        let decodedToken = null;
        try {
            decodedToken = jwtDecode(encodedToken);
        }
        catch (error) {
            // failed to decode token
            return false;
        }
        const sarArray = decodedToken.sar.split(',');
        return sarArray.includes(currentScope);
    }
}
